import { useContext } from "react";
import { SettingsContext, ShopContext } from "../App";
import "../css/PaymentPopup.css";
import Label from "./Label";
import { getTranslatedString } from "./functions/functions";

function YellgoPayPopup() {
  const { settings, checkout, init_yellgo_pay, setShowYellgoPayPopup, lang } = useContext(SettingsContext);
  const { shop } = useContext(ShopContext);

  return (
    <div className="payment-popup">
      <div className="content">
        <div className="title"><Label number={185} /></div>
        {shop.payment_methods?.[1]?.active_selfordering == 1 && (
          <button
            className="button"
            onClick={() => checkout(1)}
            style={{
              backgroundColor: settings.selfordering.color1,
              color: settings.selfordering.color2,
            }}
          >
            {getTranslatedString(shop.payment_methods[1], "label", lang)}
          </button>
        )}
        {shop.payment_methods?.[2]?.active_selfordering == 1 && (
          <button
            className="button"
            onClick={() => checkout(2)}
            style={{
              backgroundColor: settings.selfordering.color1,
              color: settings.selfordering.color2,
            }}
          >
            {getTranslatedString(shop.payment_methods[2], "label", lang)}
          </button>
        )}
        <button
          className="button primary"
          onClick={init_yellgo_pay}
          style={{
            backgroundColor: settings.selfordering.color1,
            color: settings.selfordering.color2,
          }}
        >
          <Label number={187} />
        </button>
        <button className="button" onClick={() => setShowYellgoPayPopup(false)}>
          <Label number={186} />
        </button>
      </div>
    </div>
  );
}

export default YellgoPayPopup;
